import {
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { useTranslation } from 'react-i18next';

const OnlineEventCard = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.up('md'));

  let variant: Variant;
  if (isSmallScreen) {
    variant = 'h4';
  } else if (isMediumScreen) {
    variant = 'h2';
  } else {
    variant = 'h1';
  }

  return (
    <Card
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 240,
        backgroundColor: theme.palette.customColors?.onlineCardBackground
      }}
    >
      <CardContent>
        <Typography
          variant={variant}
          align="center"
          sx={{
            fontWeight: 'bold'
          }}
        >
          {t('online_upper')}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default OnlineEventCard;
